<div class="footer-container">
  <footer class="footer-content">
    <div class="footer-row">
      <div class="footer-col footer-left">
        © 2025 Copyright:
        <a
          class="footer-link"
          href="https://accoladeelectronics.com/"
          target="_blank"
        >
          <b>Accolade Electronics Pvt. Ltd.</b>
        </a>
      </div>
      <div class="footer-col footer-right">
        <span><b>Version:</b> 6.4.1</span>
      </div>
    </div>
  </footer>
</div>
